// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"f9246ca3","363":"eede401f","815":"970464af","924":"036d90da"}[chunkId] + ".chunk.js";
};